import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Replace = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M6 4H4V10H4.25203H6.34141H10V8H7.52779C8.62643 6.7725 10.223 6 12 6C15.3137 6 18 8.68629 18 12H20C20 7.58172 16.4183 4 12 4C9.61061 4 7.46589 5.04751 6 6.70835V4ZM17.6586 14H14V16H16.4722C15.3736 17.2275 13.777 18 12 18C8.68629 18 6 15.3137 6 12H4C4 16.4183 7.58172 20 12 20C14.3894 20 16.5341 18.9525 18 17.2916V20H20V14H19.748H17.6586Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Replace;
